<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
      noGutters
    >
      <v-col cols="12">
        <InfoLine
          :label="$t('products.labels.code')"
          :value="product.code"
          :widthCols="widthCols"
        />
        <InfoLine
          :label="$t('products.labels.name')"
          :value="product.name"
          :widthCols="widthCols"
        />
        <InfoLine
          v-if="hasDescription"
          :label="$t('forms.labels.description')"
          :value="product.description"
          :widthCols="widthCols"
        />

        <InfoLine
          v-if="site"
          :label="$t('inventory.inInventoryActivity')"
          :widthCols="widthCols"
        >
          <template #value>
            <v-switch
              v-model="inInventoryActivity"
              hideDetails
              class="m-0 p-0"
              @change="onChangeInInventoryActivity"
            />
          </template>
        </InfoLine>

        <InfoLine
          v-for="({ file, label }, index) in fileList"
          :key="index"
          :file="file"
          :label="label"
          :widthCols="widthCols"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { isEmpty, isPlainObject } from 'lodash';
import InfoLine from '@/components/shared/content-views/InfoLine';

export default {
    components: {
        InfoLine,
    },
    props: {
        product: {
            type: Object,
            required: true,
        },
        site: {
            type: Object,
            default: null,
        },
        widthCols: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            inInventoryActivity: false,
            fileFields: [
                'msds_en', 'msds_fr',
                'report_en', 'report_fr',
                'procedure_en', 'procedure_fr',
            ],
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),
        fileList() {
            return this.fileFields
                .filter(fieldName => isPlainObject(this.product[fieldName]))
                .map(fieldName => ({
                    file: this.product[fieldName],
                    label: this.$t(`forms.labels.${fieldName}`),
                }));
        },
        hasDescription() {
            return !isEmpty(this.product.description);
        },
    },
    watch: {
        'product.inInventoryActivity': {
            handler(value) {
                this.inInventoryActivity = value;
            },
            immediate: true,
        },
    },
    methods: {
        async onChangeInInventoryActivity(value) {
            await this.updateSiteProduct({
                inInventoryActivity: value,
            });
        },
        async updateSiteProduct(payload) {
            const { code: data, id } = this.product;
            await this.$rq.updateSiteProduct(this.site.id, id, payload);

            this.$toasted.global.toast_success({
                message: this.$t('msg.productModified', { data }),
            });
        },
    },
};
</script>
